(() => {
  const sectionSelector = '[data-sponsoring-benefits]';
  const trackSelector = '[data-sponsoring-benefits-track]';
  const dotsSelector = '[data-sponsoring-benefits-dots]';
  const initialized = 'sponsoringBenefitsInitialized';

  const initSection = (section) => {
    if (!section || section.dataset[initialized] === 'true') return;

    const track = section.querySelector(trackSelector);
    const slides = track ? Array.from(track.children) : [];
    const dots = Array.from(section.querySelectorAll(`${dotsSelector} span`));
    if (!track || slides.length < 2 || dots.length !== slides.length) return;

    section.dataset[initialized] = 'true';

    let frame = 0;
    let activeIndex = -1;

    const closestSlideIndex = () => {
      const firstSlideOffset = slides[0].offsetLeft;

      return slides.reduce((closestIndex, slide, index) => (
        Math.abs((slide.offsetLeft - firstSlideOffset) - track.scrollLeft)
          < Math.abs((slides[closestIndex].offsetLeft - firstSlideOffset) - track.scrollLeft)
          ? index
          : closestIndex
      ), 0);
    };

    const updateDots = () => {
      frame = 0;
      const nextIndex = track.scrollWidth > track.clientWidth + 1 ? closestSlideIndex() : 0;
      if (nextIndex === activeIndex) return;

      activeIndex = nextIndex;
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
    };

    const scheduleUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(updateDots);
    };

    track.addEventListener('scroll', scheduleUpdate, { passive: true });

    const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(scheduleUpdate) : null;
    resizeObserver?.observe(track);
    if (!resizeObserver) window.addEventListener('resize', scheduleUpdate, { passive: true });

    section.sponsoringBenefitsCleanup = () => {
      if (frame) window.cancelAnimationFrame(frame);
      track.removeEventListener('scroll', scheduleUpdate);
      resizeObserver?.disconnect();
      if (!resizeObserver) window.removeEventListener('resize', scheduleUpdate);
      delete section.dataset[initialized];
    };

    updateDots();
  };

  const init = (root = document) => {
    if (root.matches?.(sectionSelector)) initSection(root);
    root.querySelectorAll?.(sectionSelector).forEach(initSection);
  };

  if (window.sponsoringBenefitsCarousel) {
    window.sponsoringBenefitsCarousel.init(document);
    return;
  }

  window.sponsoringBenefitsCarousel = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches?.(sectionSelector)
      ? event.target
      : event.target.querySelector?.(sectionSelector);
    section?.sponsoringBenefitsCleanup?.();
  });
})();
